import actionTypes from '../constants/actionTypes';
import { rejects } from 'assert';

function mailSendStart() {
    return {
        type: actionTypes.MAIL_SEND_START
    }
}

function mailSendSuccess() {
    return {
        type: actionTypes.MAIL_SEND_SUCCESS
    }
}

function mailSendError(payload) {
    return {
        type: actionTypes.MAIL_SEND_ERROR,
        payload
    }
}

export function mailSend(data) {
    var token = localStorage.getItem('token') || null;

    return dispatch => {
        dispatch(mailSendStart());

        return fetch(`${process.env.REACT_APP_SERVICE_KEYS_CLIENT_API_URL}/mail`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
            mode: 'cors'
        })
            .then((response) => {
                if (!response.ok) {
                    let textError = '';
                    switch (response.statusText) {
                        default:
                            textError = response.statusText;
                    }
                    throw new Error(textError);
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                dispatch(mailSendSuccess());
            }
            ).catch((e) => dispatch(mailSendError(e))
            );
    }
}



// WEBPACK FOOTER //
// ./src/actions/mailActions.js